import GroomingCoachShell from "@/components/GroomingCoachShell";

const BEARD_GOALS = [
  { value: "grow-fuller",   label: "Grow a fuller beard" },
  { value: "fix-patchy",    label: "Fix patchy beard" },
  { value: "beard-oil",     label: "Beard oil recs" },
  { value: "beard-balm",    label: "Beard balm recs" },
  { value: "beard-wash",    label: "Beard wash recs" },
  { value: "beard-routine", label: "Daily beard routine" },
  { value: "softer",        label: "Softer beard" },
  { value: "better-smell",  label: "Better beard smell" },
  { value: "trimmer-recs",  label: "Trimmer recs" },
];

const LOADING_STEPS = [
  "Reading your beard growth & shape…",
  "Spotting what's already working…",
  "Targeting your real concerns…",
  "Designing your routine…",
  "Picking real products in your budget…",
  "Choosing the right trimmer…",
];

export default function BeardCoachScreen() {
  return (
    <GroomingCoachShell
      feature="beard"
      endpoint="/beard/analyze"
      title="BEARD COACH"
      hero={{
        eyebrow: "PHOTO-BASED BEARD COACH",
        h1Pre:   "Upload your beard.",
        h1Em:    "Real plan, real products.",
        blurb:   "Growth stage · fullness · texture. Then a step-by-step routine with how to use everything — plus a real trimmer pick.",
      }}
      goalsList={BEARD_GOALS}
      goalsKey="beard_goals"
      loadingSteps={LOADING_STEPS}
      backRoute="/improve/grooming"
    />
  );
}
